import React from 'react';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import Hero from './components/sections/Hero';
import Servicios from './components/sections/Servicios';
import Proceso from './components/sections/Proceso';
import Precios from './components/sections/Precios';
import PorQueNosotros from './components/sections/PorQueNosotros';
import FAQ from './components/sections/FAQ';
import Contacto from './components/sections/Contacto';

function App() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Servicios />
        <Proceso />
        <Precios />
        <PorQueNosotros />
        <FAQ />
        <Contacto />
      </main>
      <Footer />
    </>
  );
}

export default App;
